module.exports = __webpack_public_path__ + "img/xhshop.156ec335.jpg";